import Chemin from './Chemin';
import './App.css'

function App() {
  return (
    <div className='App'>
      <Chemin/>
    </div>
  );
}

export default App;
